// extracted by mini-css-extract-plugin
module.exports = {"search-partner__submit":"_131a93","search-partner__action-button":"_76537f"};